// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
let defaultImage = "https://static.wixstatic.com/media/1bcec4_cd579827e100407fa61f31bedb33099b~mv2.png";

$w.onReady(function () {
	$w('#dataset1').onReady(function () {
		setTexttNumberOfRollsDisplayed();
		setDefaultImageForRollsWithoutImage();
	});	

	$w("#selectionTags1").onChange((event) => {
		let selectedTags = $w("#selectionTags1").value;

		// Define an empty filter
		let filter = wixData.filter();
		filter = filter.eq("handRoll", true); //Warning HARDCODE
		if (selectedTags) {
			// Build a filter that only includes items with all selected tags
			selectedTags.forEach(tag => {
				filter = filter.contains("description", tag.toString());
			});
		}
		$w('#dataset1').setFilter(filter)
			.then(()=> {
				setTexttNumberOfRollsDisplayed();
			});
	})
});

/**
 * Dynamically update header to display number of rolls
 */
export function setTexttNumberOfRollsDisplayed() {
	let rollCount = $w('#dataset1').getTotalCount();
	$w("#text22").text = "(" + rollCount + ")";
}

/**
 * Set a default image for all rolls without an image
 *  */
export function setDefaultImageForRollsWithoutImage(){
	$w("#repeater1").forEachItem( ($item, itemData, index) => {
		if(!itemData.image) {
			$item("#image2").src = defaultImage;
		}
	});
}